import React from 'react';
import WidgetLayout from './layout';

function Widget({
  title,
  config,
  subtitle,
  widgetBlocks,
  activeWidget,
  setActiveWidget,
  onFormSubmit
}) {
  return (
    <WidgetLayout 
      title={title}
      config={config}
      subtitle={subtitle}
      widgetBlocks={widgetBlocks}
      activeWidget={activeWidget}
      setActiveWidget={setActiveWidget}
      onFormSubmit={onFormSubmit}
    />
  );
}

export default Widget;
